module.exports = __webpack_public_path__ + "static/av-logo-251cd43b75fb3789dc4e4ba698d96ae9.svg";